import { ButtonBaseProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { ReactNode } from 'react';

export const LEFT_NAV_EXPANDED_WIDTH = 300;

export const LEFT_NAV_ITEM_HEIGHT = 40;

export const LEFT_NAV_ICON_SIZE = 20;

export const LEFT_NAV_FONT_SIZE = 14;

export interface RouteArg {
  current: string;
  prev?: string;
  stack: string[];
}
interface ProjectNameProps {
  className?: string;
}

export type RenderTextFn = (route: RouteArg) => string | undefined;

/**
 * Button props to pass into rendering LeftNavHeader
 */
export interface HeaderOpt {
  /**
   * Show back button in addition to brand logo
   * - true: Shows brand logo + back button
   * - false: Shows only brand logo
   * - undefined: Shows only brand logo (default)
   */
  showBackButton?: boolean;
  /**
   * Text to render to the right of the icon
   *
   * @param route contains:
   *   - current: current route
   *   - prev: previous route
   *   - stack: entire route stack (first entry being the current)
   * @returns text to render
   */
  renderText?: RenderTextFn;
  /**
   * Action when back button is clicked
   * Go back to previous route
   * `route` contains the route to go back to
   */
  onClick?: (route: string) => void;
  /**
   * Loading is in progress
   * LeftNav is not available to render yet
   */
  loading?: boolean;
  /**
   * current project name
   */
  projectName?: ReactNode;
  /**
   * Show the organization context switcher in the header.
   * Defaults to false — only shown in the settings nav.
   */
  showOrgSwitcher?: boolean;
  /**
   * Additional props that can be passed to the header component
   */
  [key: string]: any;
}
